// @flow
import personal from './personal';
import commercial from './commercial';
import type {Simulation} from './types';

export default function calculate(type: string, amount: number, duration: number): Simulation {
  switch (type) {
    case 'commercial':
      return commercial(amount, duration);
    case 'personal':
    default:
      return personal(amount, duration);
  }
}
